import path from 'node:path'
import { serializeConfig } from '@core-engine/config/serialize.js'
import type { ResolvedBetterstartConfig } from '@core-engine/config/types.js'
import { ensureDir, safeWriteFile } from '@core-engine/utils/fs.js'

export interface BaseScaffoldOptions {
  cwd: string
  config: ResolvedBetterstartConfig
  includeEmailTemplatesDir?: boolean
}

/**
 * Create the admin/ directory structure and admin.config.ts.
 */
export function scaffoldBase({
  cwd,
  config,
  includeEmailTemplatesDir = false
}: BaseScaffoldOptions): string[] {
  const created: string[] = []

  // Create admin/ subdirectories
  const adminDirs = [
    config.paths.admin,
    config.paths.schemas,
    path.join(config.paths.admin, 'lib'),
    path.join(config.paths.admin, 'lib', 'db'),
    path.join(config.paths.admin, 'lib', 'db', 'core'),
    path.join(config.paths.admin, 'lib', 'db', 'migrations'),
    path.join(config.paths.admin, 'lib', 'actions'),
    path.join(config.paths.admin, 'lib', 'actions', 'auth'),
    path.join(config.paths.admin, 'lib', 'actions', 'email'),
    path.join(config.paths.admin, 'lib', 'actions', 'forms'),
    path.join(config.paths.admin, 'lib', 'actions', 'media'),
    path.join(config.paths.admin, 'lib', 'actions', 'profile'),
    path.join(config.paths.admin, 'lib', 'actions', 'storage'),
    path.join(config.paths.admin, 'lib', 'actions', 'upload'),
    path.join(config.paths.admin, 'lib', 'actions', 'users'),
    path.join(config.paths.admin, 'hooks'),
    path.join(config.paths.admin, 'components', 'ui'),
    path.join(config.paths.admin, 'components', 'custom'),
    path.join(config.paths.admin, 'components', 'layouts'),
    path.join(config.paths.admin, 'components', 'shared'),
    path.join(config.paths.admin, 'components', 'shared', 'data-table'),
    path.join(config.paths.admin, 'components', 'shared', 'media'),
    path.join(config.paths.admin, 'data'),
    path.join(config.paths.admin, 'data', 'navigation'),
    path.join(config.paths.admin, 'types'),
    path.join(config.paths.admin, 'utils'),
    path.join(config.paths.admin, 'utils', 'core')
  ]

  if (includeEmailTemplatesDir) {
    adminDirs.push(path.join(config.paths.admin, 'components', 'email-templates'))
  }

  for (const dir of adminDirs) {
    ensureDir(path.resolve(cwd, dir))
  }

  // Create app route directories
  const adminDir = path.dirname(config.paths.pages)
  const appDirs = [
    config.paths.pages,
    config.paths.login,
    config.paths.api,
    path.join(adminDir, '(account)', 'profile')
  ]

  for (const dir of appDirs) {
    ensureDir(path.resolve(cwd, dir))
  }

  // Write admin.config.ts
  const configContent = serializeConfig(config)
  if (safeWriteFile(path.resolve(cwd, 'admin.config.ts'), configContent)) {
    created.push('admin.config.ts')
  }

  return created
}
